import { ChangeDetectorRef, Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfigurationManagementService } from 'src/service/configuration-management.service';
import { ExcelDownloadTemplateType } from 'src/service/file-save.service';
import { LanguageManagementService } from 'src/service/language-management.service';
import { ActiveInactiveFor, FileUploadFor, InteractionType, LocalService, NumericConfig, PageKey, PrintHtml, RelationShipRole, Status, Wrappers10 } from 'src/service/local.service';
import { QrlabelService } from 'src/service/qrlabel.service';
import { RequestManagementService } from 'src/service/request-management.service';

@Component({
  selector: 'app-qr-label-upload',
  templateUrl: './qr-label-upload.component.html',
  styleUrl: './qr-label-upload.component.scss'
})
export class QrLabelUploadComponent {
  lstSectionConfigKeys: string[] = ["qr_label_gen", "table"]; RelationShipRole = RelationShipRole; FileUploadFor = FileUploadFor; maxRange: number | null = 1000;
  ctryCode: string = ''; businessId: string = ''; userId: string = ''; interactionType = 0; isShowDeleted = false;
  numericConfig: NumericConfig = {} as NumericConfig; templateId: string = ''; maxBodyHeight = 0;

  source: Wrappers10;

  elementIds: any = {
    fileUpload: "file_upload_for_qr_label",
    split_range: 'txt_split_range'
  };

  constructor(public localService: LocalService, private route: ActivatedRoute, private configurationManagementService: ConfigurationManagementService, private languageManagementService: LanguageManagementService, private qrlabelService: QrlabelService, private router: Router, private cdr: ChangeDetectorRef, private requestManagementService: RequestManagementService) {
  }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.route.params.subscribe(routeParams => {
      this.interactionType = routeParams.interactionType;
      this.businessId = routeParams.businessId;
      this.userId = routeParams.userId;
      this.templateId = routeParams.id;
      this.configurationManagementService.ensurePageActions(PageKey.QrLabelUpload, this.businessId);
      if (this.interactionType != InteractionType.User && (!this.businessId || this.businessId.length < 5)) {
        this.localService.redirectToSeller();
      } else {
        this.localService.saveUrl();
        this.localService.setBasicParams(routeParams.ctryCode, routeParams.userId, routeParams.interactionType, routeParams.businessId);
        this.ctryCode = routeParams.ctryCode;
        this.onInitiate();
      }
    });
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetCustomBodyHeight();
    this.cdr.detectChanges();
  }

  selectedTemplateFor: number = 0; selectedUploaId = '';
  onInitiate() {
    if (this.templateId && this.templateId.length > 5) {
      this.qrlabelService.getQrLabelTemplate(this.businessId, this.templateId).subscribe(result => {
        this.selectedTemplateFor = parseInt(result.v1);
      });
    }
    this.onLoad();
  }

  onLoad() {
    if (this.localService.isUserHasBusinessRole(this.businessId, RelationShipRole.Admin)) {
      this.qrlabelService.getUploadedQrValues(this.templateId, this.source && this.source.paging ? this.source.paging : undefined, !this.isShowDeleted).subscribe(result => {
        this.source = result;
      });
    }
  }

  onAction(index: number, key?: string) {
    switch (index) {
      case 1: {
        this.requestManagementService.downloadExcelTemplate(ExcelDownloadTemplateType.QrLabelGenerator, this.templateId).subscribe(result => {
          if (result && result.length > 0) {
            this.localService.onDownloadFile(result, 'QrLabelGenerator');
          }
        });
      } break;
      case 2: {
        this.selectedUploaId = key;
        this.isOpenLabelPreviewSettings = true;
      } break;
    }
  }

  onActiveInactiveStatus(key: string) {
    this.qrlabelService.activeInactiveStatus(ActiveInactiveFor.QrGeneratorUpload, key).subscribe(result => {
      this.localService.showInformationByStatus(result.status);
      if (result.status == Status.Success)
        this.source.items = this.source.items.filter(x => x.key != key);
    });
  }

  printHtml: PrintHtml;
  isOpenLabelPreviewSettings: boolean = false;
  onHtmlGenerated(html: PrintHtml) {
    this.isOpenLabelPreviewSettings = false;
    this.printHtml = html;
  }
}
